// Renumbered by pricing_engine_v2: list_cod (2) and list_net (3) collapse into one term-agnostic
// `list`, and msrp moves from 4 to 3 to close the gap.
export var PriceAmountType;
(function (PriceAmountType) {
    PriceAmountType[PriceAmountType["WHOLESALE"] = 1] = "WHOLESALE";
    PriceAmountType[PriceAmountType["LIST"] = 2] = "LIST";
    PriceAmountType[PriceAmountType["MSRP"] = 3] = "MSRP";
})(PriceAmountType || (PriceAmountType = {}));
//# sourceMappingURL=price-amount-type.js.map